/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Notes API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotesRequest
 */
export interface NotesRequest {
    /**
     * New Notes
     * @type {string}
     * @memberof NotesRequest
     */
    notes: string;
}

export function NotesRequestFromJSON(json: any): NotesRequest {
    return NotesRequestFromJSONTyped(json, false);
}

export function NotesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notes': json['notes'],
    };
}

export function NotesRequestToJSON(value?: NotesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notes': value.notes,
    };
}


